import axios, { AxiosInstance } from 'axios';
import { CreateLogRequest } from '../../features/common/Common.types';
import {
  clientBrowser,
  clientOS,
  getUserInfo,
} from '../../features/common/Common.utils';

export class Logger implements ILogger {
  axiosInstance: AxiosInstance = axios.create({
    baseURL: this.apiUrl,
  });
  constructor(private readonly apiUrl: string) {}

  public logAction(payload: CreateLogRequest): void {
    const userInfo = getUserInfo();
    if (userInfo) {
      this.axiosInstance.post(
        'api/v1/admin/utils/log',
        JSON.stringify({
          ...payload,
          clientLocalDateTime: new Date().toString(),
          clientOS: clientOS,
          clientBrowser: clientBrowser,
        }),
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.access_token}`,
          },
        }
      );
    }
  }
}

export interface ILogger {
  logAction(request: CreateLogRequest): void;
}

export default Logger;
